import { useEffect } from "react"

const setValue = (id: string, value: number) => {
    const elem = document.getElementById(id)

    if (!elem) return

    elem.textContent = String(value).padStart(2, '0')
    elem.style.setProperty('--value', value.toString())
}

const setup = ({ expiresAt, rootId }: Props): (() => void) => {
    const expirationDate = new Date(expiresAt).getTime()

    const getDelta = () => {
        const totalSeconds = Math.round((expirationDate - new Date().getTime()) / 1000)

        const seconds = totalSeconds % 60
        const minutes = Math.floor(totalSeconds / 60) % 60
        const hours = Math.floor(totalSeconds / 3600) % 24
        const days = Math.floor(totalSeconds / 86400)
        const totalHours = days * 24 + hours

        return { totalHours, days, hours, minutes, seconds }
    }

    let intervalId: ReturnType<typeof setInterval> | undefined
    const tick = () => {
        const isExpired = Date.now() >= expirationDate

        if (isExpired) {
            const counter = document.getElementById(`${rootId}::counter`)
            const expired = document.getElementById(`${rootId}::expired`)
            const root = document.getElementById(rootId)

            expired && expired.classList.remove('hidden')
            counter && counter.classList.add('hidden')
            root && root.classList.add('hidden')
        } else {
            const { days, totalHours, hours, minutes, seconds } = getDelta()
            setValue(`${rootId}::days`, days)
            const dayElem = document.getElementById(`${rootId}::days`)
            setValue(`${rootId}::hours`, dayElem ? hours : totalHours)
            setValue(`${rootId}::minutes`, minutes)
            setValue(`${rootId}::seconds`, seconds)
        }
    }

    const start = () => {
        intervalId = setInterval(tick, 1_000)
    }

    if (document.readyState === 'complete') {
        start()
    } else {
        addEventListener('load', start)
    }

    return () => {
        if (intervalId) clearInterval(intervalId)
        removeEventListener('load', start)
    }
}

export interface Props {
    expiresAt: string
    rootId: string
}

export default function TimerJS({ expiresAt, rootId }: Props) {
    useEffect(() => setup({ expiresAt, rootId }), [expiresAt, rootId])

    return null
}
